import React, { useState } from 'react';
import HeaderBar from '../components/HeaderBar';
import { FaUser } from 'react-icons/fa';
import style from '../css/PasswordReset.module.css';
import axios from 'axios';

function PasswordReset() {
	const [oldPassword, setOldPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const handleReset = () => {
		const user = JSON.parse(localStorage.getItem('user'));

		if (!user?.id) {
			setError('User not logged in.');
			return;
		}

		if (!oldPassword || !newPassword || !confirmPassword) {
			setError('Please fill in all fields.');
			return;
		}

		if (newPassword !== confirmPassword) {
			setError('New passwords do not match!');
			return;
		}

		setLoading(true);

		axios
			.post('https://hometech-repairs.in/customerDB/reset_password.php', {
				id: user.id,
				oldPassword: oldPassword,
				newPassword: newPassword,
			})
			.then((res) => {
				setLoading(false);
				if (res.data.status) {
					setError('Password has been reset successfully.');
					setOldPassword('');
					setNewPassword('');
					setConfirmPassword('');
				} else {
					setError(res.data.msg || 'Password reset failed.');
				}
			})
			.catch((err) => {
				setLoading(false);
				console.error('Reset error:', err);
				setError('An error occurred while resetting the password.');
			});
	};

	return (
		<div>
			<HeaderBar
				text="Reset Password"
				icon={<FaUser color="black" size={20} />}
				navi="/profile"
			/>

			<div className={style.form}>
				<input
					type="password"
					value={oldPassword}
					onChange={(e) => {
						setOldPassword(e.target.value);
						setError('');
					}}
					className={style.input}
					placeholder="Old Password"
				/>

				<input
					type="password"
					value={newPassword}
					onChange={(e) => {
						setNewPassword(e.target.value);
						setError('');
					}}
					className={style.input}
					placeholder="New Password"
				/>

				<input
					type="password"
					value={confirmPassword}
					onChange={(e) => {
						setConfirmPassword(e.target.value);
						setError('');
					}}
					className={style.input}
					placeholder="Confirm Password"
				/>

				<button
					onClick={handleReset}
					className={style.resetButton}
					disabled={loading}
				>
					{loading ? 'Resetting...' : 'Reset Password'}
				</button>
			</div>
			{error && (
				<p style={{ textAlign: 'center', marginTop: '20px' }}>{error}</p>
			)}

			<div style={{ textAlign: 'center', marginTop: '20px' }}>
				<p>
					© 2025 HomeTech Repairs. <br /> All rights reserved.
				</p>
			</div>
		</div>
	);
}

export default PasswordReset;
